import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useSettings } from "../context/SettingsContext";
import { X, Gift, Copy } from "lucide-react";
import { toast } from "sonner";

export default function EmailPopup() {
  const settings = useSettings();
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [code, setCode] = useState(null);
  const popup = settings?.popup;

  useEffect(() => {
    if (!popup?.enabled) return;
    if (localStorage.getItem("pa_popup_done")) return;
    const t = setTimeout(() => setOpen(true), (popup.delay || 12) * 1000);
    return () => clearTimeout(t);
  }, [popup]);

  const close = () => { setOpen(false); localStorage.setItem("pa_popup_done", "1"); };
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/newsletter", { email }); setCode(popup.code || "WELCOME10"); localStorage.setItem("pa_popup_done", "1"); }
    catch { toast.error("Възникна грешка."); }
  };
  const copy = () => { navigator.clipboard.writeText(code); toast.success("Кодът е копиран"); };

  if (!open || !popup) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4" data-testid="email-popup">
      <div className="absolute inset-0 bg-navy/60 backdrop-blur-sm" onClick={close} />
      <div className="relative bg-ivory max-w-md w-full p-8 border border-gold">
        <button onClick={close} className="absolute top-3 right-3 text-charcoal/50 hover:text-navy" data-testid="popup-close"><X size={22} /></button>
        <div className="w-14 h-14 border border-gold flex items-center justify-center text-gold mx-auto mb-5"><Gift size={26} strokeWidth={1.3} /></div>
        {code ? (
          <div className="text-center">
            <h3 className="font-serif text-2xl text-navy">Вашият промо код</h3>
            <p className="text-charcoal/60 mt-2 text-sm">Използвайте го при поръчка за -10% отстъпка.</p>
            <button onClick={copy} className="mt-5 w-full border-2 border-dashed border-gold py-3 font-mono text-xl text-navy tracking-widest flex items-center justify-center gap-2 hover:bg-gold/10" data-testid="popup-code">{code} <Copy size={16} className="text-gold" /></button>
            <button onClick={close} className="btn-gold w-full py-3 rounded-sm mt-4">Към пазаруване</button>
          </div>
        ) : (
          <form onSubmit={submit} className="text-center">
            <h3 className="font-serif text-2xl text-navy leading-snug">{popup.title}</h3>
            <p className="text-charcoal/60 mt-2 text-sm">{popup.subtitle}</p>
            <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Вашият имейл"
                   className="w-full border border-stone px-4 py-3 mt-5 outline-none focus:border-gold text-center" data-testid="popup-email" />
            <button type="submit" className="btn-gold w-full py-3.5 rounded-sm mt-3" data-testid="popup-submit">Вземи моя код</button>
            <button type="button" onClick={close} className="text-xs text-charcoal/50 mt-3 hover:text-navy">Не, благодаря</button>
          </form>
        )}
      </div>
    </div>
  );
}
